import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-incoming',
  templateUrl: './stock-incoming.component.html',
  styleUrls: ['./stock-incoming.component.css']
})
export class StockIncomingComponent implements OnInit {
    stockKeyno;

    public itemsListStockIncomings: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadStockIncomings() {
        if (!!this.stockKeyno) {
            this.itemsListStockIncomings = await this.datatask.Post(421, { stock_keyno: this.stockKeyno });
        }
    }

    private async init() {
        this.loadStockIncomings();
    }

    ngOnInit() {
        this.init();
    }
}
